import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import './assets/css/font.css'
import "lib-flexible/flexible";
import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility);
Vue.config.productionTip = false;
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)
//引入自定义指令，方便全局使用
import myDirective from '@/assets/myDirective/myDirective.js';
Vue.use(myDirective);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
